module.exports = __webpack_public_path__ + "static/media/sf-trial-1.00437815.mp3";